var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({ marginBottom: ((_vm.height * 0.05) + "px") }),attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }